/**
 * 404 Not Found page.
 * Theme: 2026 branding (aligned with HomePage, AboutPage).
 */

import { Link } from 'react-router-dom';

function NotFoundHeroPattern(): JSX.Element {
  return (
    <svg className="absolute inset-0 h-full w-full" aria-hidden="true">
      <defs>
        <pattern id="notfound-hero-grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#notfound-hero-grid)" />
    </svg>
  );
}

export function NotFoundPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      {/* Hero — 2026 theme */}
      <section
        className="relative text-white overflow-hidden py-12 sm:py-16"
        style={{ backgroundColor: 'var(--smb-primary, #1e3a5f)' }}
      >
        <NotFoundHeroPattern />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'linear-gradient(to bottom, #1e3a5f 0%, #1e3a5f 50%, #0f172a 100%)',
          }}
          aria-hidden="true"
        />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-white/85 hover:text-white text-sm">
            ← Back to Home
          </Link>
        </div>
      </section>

      {/* Content */}
      <main
        id="main-content"
        className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16"
        role="main"
      >
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 sm:p-12 text-center">
          <h1 className="text-5xl sm:text-6xl font-bold text-[#1e3a5f] mb-3">404</h1>
          <p className="text-lg text-gray-600 mb-8">Page not found.</p>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg px-6 py-3.5 font-semibold text-white bg-[#1e3a5f] hover:bg-[#16304a] transition-colors focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/50 focus:ring-offset-2"
          >
            Go to Home
          </Link>
        </div>
      </main>
    </div>
  );
}
